<div class="row a_center">
    <svg-icon *ngFor="let star of stars" [ngClass]="star.class" (click)="starSelected(star.id)" src="../../../assets/svg/star.svg"></svg-icon>
</div>